import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';

import NavTab, { NavTabItem } from 'partial/components/NavTab';
import Cashback from 'core-modules/cashback/containers/Cashback';
import OnboardingContainer from 'core-modules/merchant-onboarding/containers/OnboardingContainer';

import { useMerchantList, useSelectMerchant } from '../hooks';
import MerchantDetail from '../components/MerchantDetail';
import MerchantHeader from '../components/MerchantHeader';

function BillerProfile({ data, isLoading, activeAccount }) {
  const match = useRouteMatch();
  const [billerId, setBillerId] = useState();
  const filter = useMemo(
    () => ({
      sort: 'name:asc',
    }),
    []
  );
  const [, list] = useMerchantList(filter);
  useSelectMerchant(billerId);

  useEffect(() => {
    if (list[0]) {
      setBillerId(list[0]?.id);
    }
  }, [list]);

  return (
    <div className="flex-1 relative z-0 flex overflow-hidden">
      <main className="flex-1 relative z-0 overflow-y-scroll focus:outline-none xl:order-last py-5 px-5">
        <div className="bg-white h-full flex flex-col rounded-xl">
          <MerchantHeader
            data={data}
            isLoading={isLoading}
            readOnly // TODO
          />
          <div className="border-b border-gray-200 mb-2">
            <NavTab>
              {/* <NavTabItem to={`${match.url}/dashboard`} label="Dashboard" /> */}
              {data.approval_status === 'APPROVED' ? (
                <>
                  <NavTabItem to={`${match.url}/details`} label="Profile" />
                  <NavTabItem to={`${match.url}/cashback`} label="Cashback" />
                </>
              ) : (
                <>
                  {activeAccount?.role !== 'DEV' ? (
                    <NavTabItem to={`${match.url}/kyc`} label="KYC" />
                  ) : null}
                </>
              )}
              {/* <NavTabItem to={`${match.url}/transactions`} label="Transactions" /> */}
              {/* {activeAccount?.role !== 'DEV' ? (
              <NavTabItem to={`${match.url}/channels`} label="Channels" />
            ) : null} */}

              {/* <NavTabItem to={`${match.url}/invoice`} label="Invoice" /> */}
              {/* {activeAccount?.role !== 'BUSINESS' ? (
              <NavTabItem to={`${match.url}/integration`} label="Integration" />
            ) : null} */}
              {/* {activeAccount?.role === 'OWNER' ? (
              <NavTabItem to={`${match.url}/users`} label="Users" />
            ) : null} */}
            </NavTab>
          </div>
          {data.id ? (
            <div className="overflow-y-auto px-4 mt-4 pb-8 sm:px-6 lg:px-8 flex-1 flex flex-col container mx-auto">
              <Switch>
                {/* <Route
                path={`${match.path}/dashboard`}
                component={MerchantDashboard}
              /> */}
                <Route path={`${match.path}/details`}>
                  {data.approval_status !== 'APPROVED' ? (
                    <Redirect to={`${match.path}/kyc`} />
                  ) : (
                    <MerchantDetail data={data} />
                  )}
                </Route>
                <Route path={`${match.path}/cashback`} component={Cashback} />
                {/* <Route path={`${match.path}/integration`}>
                <div className="space-y-4">
                  <IntegrationDashboard merchant={data} />
                  <ApiKeysContainer />
                </div>
              </Route> */}
                {/* <Route
                path={`${match.path}/transactions`}
                component={TransactionTable}
              />
              <Route path={`${match.path}/channels`}>
                <MerchantChannels merchantId={data?.id} />
              </Route> */}
                <Route path={`${match.path}/kyc`}>
                  {data.approval_status === 'APPROVED' ? (
                    <Redirect to={`${match.path}/details`} />
                  ) : (
                    <OnboardingContainer key={data?.id} merchant={data} />
                  )}
                </Route>
                {/* <Route path={`${match.path}/invoice`} component={InvoiceRoutes} />
              {/* <Route path={`${match.path}/users`} component={AclUsers} /> */}
                {/* <Redirect to={`${match.url}/dashboard`} /> */}
                <Redirect to={`${match.url}/details`} />
              </Switch>
            </div>
          ) : null}
        </div>
      </main>
    </div>
  );
}

BillerProfile.defaultProps = {
  data: {},
  isLoading: true,
  activeAccount: {},
};

BillerProfile.propTypes = {
  data: PropTypes.instanceOf(Object),
  isLoading: PropTypes.bool,
  activeAccount: PropTypes.instanceOf(Object),
};

export default BillerProfile;
